import axiosApiInstance from 'utils/axios-api-instance'

export const fetchModerationBooks = () =>
	axiosApiInstance.get(`api/books/moderator`)
